import {ReactComponent as IconExpand} from 'img/icon/expand_more.svg'
import {ReactComponent as IconCollapse} from 'img/icon/expand_less.svg'

const IconExpandContract = (props) => {
    if(typeof props.value !== 'boolean') return null
    else{
        return props.value
            ?<IconExpand width={props.width} height={props.height} />
            :<IconCollapse width={props.width} height={props.height} />
    }
}
IconExpandContract.defaultProps = {
    width: 25,
    height: 25
}

export default IconExpandContract